import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'
import { BrowserRouter } from 'react-router-dom'
import './theme/set-numeral-local'
import Providers from 'app/providers'

/**
 * If running in production mode, disable console logs and errors
 */
if (process.env.NODE_ENV === 'production') {
  console.log = function () {}
  console.info = function () {}
  console.error = function () {}
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Providers>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Providers>
  </React.StrictMode>
)
